// extracted by mini-css-extract-plugin
module.exports = {"root":"PromoCard_root__P4pmf","action":"PromoCard_action__CrAZI","finalPrice":"PromoCard_finalPrice__J6nJw","title":"PromoCard_title__3AfK1"};